var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { action, makeObservable, observable } from 'mobx';
import { eventSystem } from '@business/event-system';
export default class Payment {
    constructor() {
        // Whether the lazily-loaded payment component (and its SDK chunk) has
        // finished loading and rendered its fields. Used to keep the cart confirm
        // button disabled until the payment UI is actually interactive.
        Object.defineProperty(this, "isPaymentComponentReady", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "isPaymentModalOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "handleModalOpened", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setPaymentModalOpen(true)
        });
        Object.defineProperty(this, "handleModalClosed", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.setPaymentModalOpen(false)
        });
        makeObservable(this);
        eventSystem.on('internal/payment-modal-opened', this.handleModalOpened);
        eventSystem.on('internal/payment-modal-closed', this.handleModalClosed);
    }
    // For resetStore(): a replaced instance must not keep listening.
    dispose() {
        eventSystem.off('internal/payment-modal-opened', this.handleModalOpened);
        eventSystem.off('internal/payment-modal-closed', this.handleModalClosed);
    }
    setPaymentComponentReady(isReady) {
        this.isPaymentComponentReady = isReady;
    }
    setPaymentModalOpen(isOpen) {
        this.isPaymentModalOpen = isOpen;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], Payment.prototype, "isPaymentComponentReady", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], Payment.prototype, "isPaymentModalOpen", void 0);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "setPaymentComponentReady", null);
__decorate([
    action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], Payment.prototype, "setPaymentModalOpen", null);
